import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { CampaignType, useMarketplaceCampaignReportSummaryQuery } from '@anytag/graphql';
import { getValuableVariables } from '@anytag/shared-utils';
import {
  PostReportEmpty,
  PostReportProvider,
  usePostReportFilter,
  MarketplaceReportGrid,
  MarketplaceReportTable,
  MarketplaceReportFilter,
  MarketplaceReportSummary
} from '@anytag/shared-organisms';
import { PostReportMode } from '@anytag/shared-types';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';

export const MarketplaceReport = () => {
  const { marketplace, hasTrackingTune, hasTrackingReferral } = useMarketplaceDetailsContext();

  const { id } = marketplace;
  const { filter, setFilter, state } = usePostReportFilter();
  const { data, loading } = useMarketplaceCampaignReportSummaryQuery({
    variables: getValuableVariables({
      campaignId: id,
      keyword: filter.keyword,
      endDate: filter.endDate,
      startDate: filter.startDate
    })
  });

  const summaryData = data?.marketplaceCampaignReportSummary || undefined;

  return (
    <PostReportProvider
      value={{ campaignType: CampaignType.MARKETPLACE, hasTracking: hasTrackingTune || hasTrackingReferral }}
    >
      <MarketplaceReportFilter filter={filter} setFilter={setFilter} campaignId={id} segmentState={state} />

      <RenderDataWithFallback loading={loading} hasNoData={!summaryData?.postCount} noDataNode={<PostReportEmpty />}>
        <MarketplaceReportSummary data={summaryData} marketplace={marketplace} />

        {filter.mode === PostReportMode.GRID ? (
          <MarketplaceReportGrid marketplace={marketplace} />
        ) : (
          <MarketplaceReportTable marketplace={marketplace} summaryData={summaryData} />
        )}
      </RenderDataWithFallback>
    </PostReportProvider>
  );
};
